import { useState } from "react";

export default function useLanguage() {
  const [language, setLanguage] = useState(localStorage.getItem("locale") || "en");

  const saveLanguage = (savingLocale) => {
    localStorage.setItem("locale", savingLocale);
    setLanguage(savingLocale);
  };

  return {
    setLanguage: saveLanguage,
    language
  };
}
